import { Helmet } from "fusion-plugin-react-helmet-async";
import { LuLoaderCircle } from "react-icons/lu";

const Loader = ({ text }) => {
  return (
    <>
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
      </Helmet>
      <div
        className="tw-fixed tw-inset-0 tw-z-[100] tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-bg-white/85 tw-backdrop-blur-sm"
        role="status"
        aria-live="polite"
      >
        <LuLoaderCircle
          className="tw-h-10 tw-w-10 tw-animate-spin tw-text-dis-deep-blue"
          aria-hidden="true"
        />
        <p className="tw-m-0 tw-max-w-[min(90vw,400px)] tw-text-center tw-text-base tw-font-medium tw-text-dis-navy">
          {text}
        </p>
      </div>
    </>
  );
};

export default Loader;
